export const getRelease = (): string => {
  if (
    import.meta.env.VITE_APP_VERSION &&
    import.meta.env.VITE_APP_COMMIT_HASH
  ) {
    return `${import.meta.env.VITE_APP_VERSION}_${
      import.meta.env.VITE_APP_COMMIT_HASH
    }`;
  }

  return 'local';
};
